import { capitalize } from 'lodash';

import { useOnBoardingDrawer } from '../OnBoardingDrawerProvider';
import type { IRegistrationFlowOption } from './types';

export default function useRegistrationFlowData(): IRegistrationFlowOption {
  const {
    contextData: { patient },
  } = useOnBoardingDrawer();

  const headerText = `${
    patient?.firstName ? capitalize(patient.firstName) : 'Patient'
  } Registered Successfully!`;

  const patientName = patient?.firstName ? capitalize(patient.firstName) : 'patient';

  return {
    patientDetailesStep: {
      btnText: 'Continue to Invite Patient',
      headerText: headerText,
      bodyTexts: [
        'Congratulations, a new patient has successfully been registered.',
        `On the next screen, you will be able to invite ${patientName} to download the OneStep app.`,
      ],
      mixpanelEventName: 'invite_to_app',
    },
  };
}
